export default {
      id: "as-accessible-toilet-usage",
      viewBox: "0 0 56 56",
      url: "/" + "sprite.svg#as-accessible-toilet",
      toString: function () {
        return this.url;
      }
    }